import {
  cn,
  DropdownMenuItem,
  Icon,
  DropdownMenuSeparator,
  Flex,
} from '@kognitos/lattice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import type { IDropdownMenuItem } from './types';
import { getActiveUrl } from './util';
import { HotkeyTrigger } from '@/shared/components/HotkeyTrigger';

const DropdownMenuItems = ({ items }: { items: IDropdownMenuItem[] }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeUrl = getActiveUrl(items, pathname);
  return (
    <>
      {items.map((item, index) => {
        const onHotkeyPress = () => {
          if (item.url) {
            navigate(item.url);
          }
          if (item.onClick) {
            item.onClick();
          }
        };

        if (item.type === 'separator') {
          return <DropdownMenuSeparator key={item.key} />;
        }

        return (
          <DropdownMenuItem
            key={item.title || `item-${index}`}
            onClick={item.disabled ? undefined : item.onClick}
            className={item.url ? 'p-0' : ''}
            disabled={item.disabled}
          >
            {item.url ? (
              <Link
                to={item.url}
                className={cn(
                  'px-2 py-1.5 w-full',
                  item.url === activeUrl && 'active',
                )}
                aria-current={item.url === activeUrl ? 'page' : undefined}
                target={item.isExternalUrl ? '_blank' : undefined}
                rel={item.isExternalUrl ? 'noopener noreferrer' : undefined}
                onClick={
                  item.disabled
                    ? e => {
                        e.preventDefault();
                      }
                    : undefined
                }
              >
                <Flex align="center">
                  {item.icon && (
                    <Icon type={item.icon} className="mr-2 h-4 w-4" />
                  )}
                  <span>{item.title}</span>
                  {item.shortcut && item.onClick && !item.disabled && (
                    <HotkeyTrigger
                      shortcut={item.shortcut}
                      onHotkeyPress={onHotkeyPress}
                    />
                  )}
                </Flex>
              </Link>
            ) : (
              <>
                {item.icon && <Icon type={item.icon} className="h-4 w-4" />}
                <span>{item.title}</span>
                {item.shortcut && item.onClick && !item.disabled && (
                  <HotkeyTrigger
                    shortcut={item.shortcut}
                    onHotkeyPress={onHotkeyPress}
                  />
                )}
              </>
            )}
          </DropdownMenuItem>
        );
      })}
    </>
  );
};

export default DropdownMenuItems;
